/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseMultiFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/General/BaseMultiFormElement";

export default class FormElementDropDown extends BaseMultiFormElement {

	selectedIndex: number = -1

	constructor(title, isRequired) {
		super(FormElementType.DROP_DOWN, title, isRequired);
	}

	numberOfAnswers(){
		return this.selectedIndex >= 0 ? 1 : 0
	}

}
